import { Directive, TemplateRef, ViewContainerRef, Input, OnDestroy, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { Breakpoint, BreakpointState, MediaQueryService } from '../../services/media-query.service';

@Directive({
  selector: '[tdWbIfScreen]',
  exportAs: 'tdWbIfScreen'
})
export class IfScreenDirective implements OnDestroy {
  private readonly viewContainer = inject(ViewContainerRef);
  private readonly templateRef = inject<TemplateRef<unknown>>(TemplateRef);
  private readonly mediaQueryService = inject(MediaQueryService);

  private subscription: Subscription;
  private isViewCreated: boolean = false;

  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input()
  set tdWbIfScreen(breakpointStrings: Array<string>) {
    this.unsubscribe();
    const breakpoints = breakpointStrings.map((bp: string): Breakpoint => Breakpoint[bp.toUpperCase()]);
    this.subscription = this.mediaQueryService.observe(...breakpoints).subscribe((breakpointState: BreakpointState): void => {
      this.updateView(breakpointState.matches);
    });
  }

  private updateView(matches: boolean): void {
    if (matches && !this.isViewCreated) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.isViewCreated = true;
    } else if (!matches && this.isViewCreated) {
      this.viewContainer.clear();
      this.isViewCreated = false;
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe();
  }

  private unsubscribe(): void {
    if (this.subscription !== undefined) {
      this.subscription.unsubscribe();
    }
  }
}
